import { computed } from 'vue'

import useBasket from '@/hooks/useBasket'
import usePerson from '@/hooks/usePerson'
import { isRequired } from '@/utils/CustomErrors'

// HOOKS
const { basket } = useBasket()
const { getPerson } = usePerson() // TODO: when to use getPerson instead of basket.persons (and then find by id)

// COMPUTED
const isExistingCustomerBasket = computed(() => {
  return basket.existingCustomer
})

// METHODS

/**
 * isExistingCustomer returns true for persons with an existing partnerNumber
 * @param {string} personId
 * @returns {boolean}
 */
function isExistingCustomer(personId = isRequired('personId')) {
  if (!isExistingCustomerBasket.value) return false

  const person = getPerson(personId)
  return !!person.partnerNumber
}

export default function useExistingCustomer() {
  return {
    // COMPUTED
    isExistingCustomerBasket,
    // METHODS
    isExistingCustomer,
  }
}
